import con from '../../../../../../connection';
var path = '/files';
var files = function (url) { return function (file_id) { return ({
    // 依頼ファイルダウンロード
    get: function (param) { return con.getFile("" + url + path, param); },
    // 依頼ファイルアップロード
    post: function (param) { return con.post("" + url + path, param); },
    // 依頼ファイル削除
    delete: function () { return con.delete("" + url + path + "/" + (file_id || ''), {}); },
}); }; };
export default files;
